/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassStudentTagViewModel } from "../types/ClassStudentTagViewModel.ts";

export const classStudentTagViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da turma.")),
  name: z
    .string()
    .describe('Rótulo da turma: "Código do curso - Descrição".')
    .nullish(),
}) as unknown as ToZod<ClassStudentTagViewModel>;
